import { gql } from 'apollo-boost'

const DOCUMENT_MENU_SCRAPING_SCREENSHOT_URL = gql`
  query documentMenuScrapingScreenshotUrl(
    $bucketName: String!
    $fileKey: String!
  ) {
    documentMenuScrapingScreenshotUrl(
      bucketName: $bucketName
      fileKey: $fileKey
    )
  }
`

export default DOCUMENT_MENU_SCRAPING_SCREENSHOT_URL
